import { useEffect, useState } from "react";
import NoDataItem from "../NoDataItem";
import { BsNodePlus, BsTable } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../../../../Translations/LenguageContext";
import NewTableModal from "./NewTableModal";
import { BiPlus } from "react-icons/bi";
import APIConnectorModal from "../Data/APIConnectorModal";
import ErrorPage from "../../../../Components/ErrorPage";
import { TbGalaxy, TbPlus, TbReload } from "react-icons/tb";
import { Dropdown } from "react-bootstrap";
import DeleteRecordModal from "../../../ViewComponents/DeleteRecordModal";
import { MdOutlineContentCopy, MdSchema } from "react-icons/md";
import { LuChevronFirst, LuChevronLast } from "react-icons/lu";
import OpenTableData from "./OpenTableData";

const MainSqlData = ({ fetchRecords, records, schema, schemas, setSchema, instanceData }) => {
    const { t } = useLanguage()
    const user_id = sessionStorage.getItem("user_id");
    const navigate = useNavigate();
    const { project_id, db_id, coll_id } = useParams()
    const [viewType, setViewType] = useState("table_view")
    const [loadingTable, setLoadingTable] = useState(true);
    const [error, setError] = useState(false);
    const [openModal, setOpenModal] = useState(false)
    const [showAPIConn, setShowApiConn] = useState(false)
    const [tableDetails, setTableDetails] = useState({})
    const [tableData, setTableData] = useState([])
    const [openModalNewRec, setOpenModalNewRec] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [recordObject, setRecordObject] = useState({})
    const [copied, setCopied] = useState(false)
    const [region, setRegion] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);


    const OpenSelectedModal = () => {
        setOpenModal(true)
    }

    const title_empty = "Create your firts table"
    const title_item = "Choose a table"
    const subtitle_empty = "SQL tables are the fundamental structures used to store data in a relational database."
    const img_empty = "sqltable"

    const title_empty_col = "This table is empty!"
    const subtitle_empty_col = "Data can be inserted through APIs or directly via the platform or using SQL queries."
    const img_empty_col = "sqltable"

    useEffect(() => {
        if (project_id && db_id && coll_id) {
            fetchTable(user_id, db_id, coll_id, currentPage);
        }
    }, [user_id, project_id, db_id, coll_id, currentPage]);


    const handleOpenTable = (table_id) => {
        navigate(`/project_panel/${project_id}/databases/${db_id}/data/${table_id}`)
    }

    const fetchTable = async (user_id, db_id, table_id, page = 1) => {
        setLoadingTable(true);
        try {
            const response = await fetch("https://backend.erioon.com/get_specific_table", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id,
                    db_id,
                    table_id,
                    schema,
                    page,
                }),
            });
            if (response.ok) {
                const result = await response.json();
                const table = result.records || [];
                setTableData(Array.isArray(table) ? table : []);
                setRegion(result.region);
                setTotalRecords(result.totalRecords);
            } else {
                const errorData = await response.json();
                setError(errorData.message || "Failed to load files.");
            }
        } catch (err) {
            setError("Failed to connect to the server. Please try again later.");
        } finally {
            setTimeout(() => {
                setLoadingTable(false);
            }, 800);
        }
    };

    const handleDeleteClick = (table_id, schema) => {
        setShowDeleteModal(true)
        const selectedRecord = records.find((item) => item.tables[table_id].table_id === table_id);
        if (selectedRecord) {
            const obj = {
                _id: {
                    db_id: db_id,
                    table_id: table_id,
                    schema: schema
                }
            }
            setRecordObject(obj)
        }
    }

    const handleClose = () => {
        setShowDeleteModal(false)
        setRecordObject({})
    }


    const RefreshTable = () => {
        navigate(`/project_panel/${project_id}/databases/${db_id}/data`)
        fetchRecords()
    }

    function handlePageChange(action) {
        const totalPages = Math.ceil(totalRecords / 50);

        if (action === "first") {
            setCurrentPage(1);
        } else if (action === "last") {
            setCurrentPage(totalPages);
        } else if (action === "prev" && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        } else if (action === "next" && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    }


    const handleCopyClick = () => {
        navigator.clipboard.writeText(coll_id);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };


    if (error) {
        return <ErrorPage />;
    }


    return (
        <div className="open_db_main_entire_body">
            <div className="open_db_main_header">
                {records.some(record =>
                    record.tables &&
                    Object.keys(record.tables).length > 0
                ) && (
                        <>
                            {/* <button className={`open_db_main_header_btns ${viewType === "code_editor" ? "open_db_main_header_btn_selected" : ""}`} onClick={() => setViewType("code_editor")}><BiLogoPython /> Python editor</button> */}
                            {/* <button className={`open_db_main_header_btns ${viewType === "json_view" ? "open_db_main_header_btn_selected" : ""}`} onClick={() => setViewType("json_view")}>JSON view</button> */}
                            {/* <button className={`open_db_main_header_btns ${viewType === "table_view" ? "open_db_main_header_btn_selected" : ""}`} onClick={() => setViewType("table_view")}>Table view</button> */}
                        </>
                    )}
            </div>

            <div className="open_db_main_body">
                <div className={`${records.some(record =>
                    record.tables &&
                    Object.keys(record.tables).length > 0
                ) ? "open_db_main_sidebar_opened" : "open_db_main_sidebar"}`}>

                    <div className="open_db_main_sidebar_header">
                        <div className="open_db_main_sidebar_header_title">
                            <p>
                                <BsTable /> Tables
                            </p>
                            <div className="open_db_main_sidebar_header_title_btn_cont">
                                <button className="open_db_main_sidebar_header_title_btn" onClick={OpenSelectedModal}><TbPlus /></button>
                                <button className="open_db_main_sidebar_header_title_btn" onClick={fetchRecords}><TbReload /></button>
                            </div>
                        </div>
                        <div className="open_db_main_sidebar_header_title">
                            <p>
                                <MdSchema />
                            </p>
                            <select
                                className="schema_option"
                                value={schema}
                                onChange={(e) => setSchema(e.target.value)}
                            >
                                {schemas.length > 0 ? (
                                    schemas.map((sch) => (
                                        <option key={sch} value={sch}>
                                            {sch}
                                        </option>
                                    ))
                                ) : (
                                    <option disabled>No schemas found</option>
                                )}
                            </select>
                        </div>


                    </div>
                    <div className="open_db_main_sidebar_body">
                        {(() => {
                            const allTables = records
                                .flatMap(record => record.tables ? Object.values(record.tables) : [])
                                .filter(table => table.schema === schema);

                            if (allTables.length === 0) {
                                return <p className="no_tables_message">No tables for this schema</p>;
                            }

                            const sortedTables = allTables.sort((a, b) => {
                                const nameA = a.table_name.toLowerCase();
                                const nameB = b.table_name.toLowerCase();
                                if (!isNaN(nameA) && !isNaN(nameB)) {
                                    return Number(nameA) - Number(nameB);
                                }
                                return nameA.localeCompare(nameB);
                            });

                            return sortedTables.map((table) => (
                                <div
                                    key={table.table_id}
                                    className={`open_db_main_sidebar_body_link ${coll_id === table.table_id ? "open_db_main_sidebar_body_link_selected" : ""}`}
                                >
                                    <p
                                        onClick={() => {
                                            handleOpenTable(table.table_id);
                                            fetchTable(user_id, db_id, table.table_id, 1);
                                        }}
                                    >
                                        - {table.table_name}
                                    </p>
                                    <Dropdown>
                                        <div className="property_btn_action_toggle">
                                            <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                                <i className="fa-solid fa-ellipsis-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="custom-dropdown-menu">
                                                <Dropdown.Item
                                                    className="drop_down_item delete"
                                                    onClick={() => handleDeleteClick(table.table_id, table.schema)}
                                                >
                                                    <i className="fa-solid fa-trash"></i> {t.delete}
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </div>
                                    </Dropdown>
                                </div>
                            ));
                        })()}
                    </div>

                </div>
                {records.some(record =>
                    record.tables &&
                    Object.keys(record.tables).length > 0
                ) ? (
                    <div className="open_db_body">
                        {coll_id ? (
                            <>
                                <div className="open_db_body_header">
                                    {
                                        records.map(record => {
                                            const tables = record.tables || {};
                                            const tablesArray = Object.values(tables);

                                            const selectedTable = tablesArray.find(
                                                table => table.table_id === coll_id
                                            );

                                            if (selectedTable) {
                                                return (
                                                    <div key={selectedTable.table_id} className="open_db_body_header_dets">
                                                        <div className="collection_details_cont">
                                                            <div className="connection_btn_cont">
                                                                {/* <button className="connection_btn" onClick={() => showModalNewRec(user_id, db_id, coll_id)}><i><BiPlus /></i></button> */}
                                                                <button className="connection_btn" onClick={() => fetchTable(user_id, db_id, coll_id)}><i><TbReload /></i></button>
                                                                {/* <button className="connection_btn" onClick={() => showApiConnection(selectedTable)}><i><BiQuestionMark /></i> </button> */}
                                                            </div>
                                                            <div>
                                                                <p className="coll_title">
                                                                    {selectedTable.table_name}
                                                                    <span className={`${coll_id ? "new_section_main_view_title_db_id" : "new_section_main_view_title_db_id_loading"}`}>
                                                                        {coll_id}
                                                                        {coll_id && (
                                                                            <i onClick={handleCopyClick}>
                                                                                {copied ? (
                                                                                    <i className="fa-solid fa-check"></i>
                                                                                ) : (
                                                                                    <MdOutlineContentCopy />
                                                                                )}
                                                                            </i>
                                                                        )}
                                                                    </span>

                                                                </p>
                                                                <p className="coll_desc">
                                                                    <span className="coll_desc_span" title={selectedTable.table_desc}>{selectedTable.table_desc}</span>
                                                                </p>

                                                            </div>

                                                        </div>
                                                    </div>
                                                );
                                            }

                                            return null;
                                        })
                                    }
                                </div>

                                {loadingTable ? (
                                    <div className="body_loading_db_cont">
                                        <div className="loading_logo_erioon">
                                            <p className="loading_logo_erioon_icon"><i><TbGalaxy /></i></p>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        {tableData.length > 0 ? (
                                            <OpenTableData
                                                tableData={tableData}
                                                fetchTable={fetchTable}
                                                currentPage={currentPage}
                                            />
                                        ) : (
                                            <NoDataItem
                                                fetchRecords={fetchRecords}
                                                title={title_empty_col}
                                                subtitle={subtitle_empty_col}
                                                item={img_empty}
                                                showBtn={false}
                                                dbType={"sql"}
                                            />
                                        )}
                                    </>
                                )}


                                {totalRecords > 0 && (
                                    <div className="collection_footer_cont">
                                        <div className="page_indicator_cont">
                                            <button
                                                onClick={() => handlePageChange("first")}
                                                disabled={currentPage === 1 || loadingTable}
                                            >
                                                <i className=""><LuChevronFirst /></i>
                                            </button>

                                            <button
                                                onClick={() => handlePageChange("prev")}
                                                disabled={currentPage === 1 || loadingTable}
                                            >
                                                <i className="fa-solid fa-chevron-left"></i>
                                            </button>

                                            <p className="page_indicator_cont_pages">
                                                {currentPage} / {Math.ceil(totalRecords / 50)}
                                            </p>

                                            <button
                                                onClick={() => handlePageChange("next")}
                                                disabled={currentPage >= Math.ceil(totalRecords / 50) || loadingTable}
                                            >
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </button>

                                            <button
                                                onClick={() => handlePageChange("last")}
                                                disabled={currentPage >= Math.ceil(totalRecords / 50) || loadingTable}
                                            >
                                                <i className=""><LuChevronLast /></i>
                                            </button>
                                        </div>
                                        <p className="total_records_coll">
                                            {Number(totalRecords) <= 1 ? (
                                                <>
                                                    {totalRecords} record
                                                </>
                                            ) : (
                                                <>
                                                    {totalRecords} total records
                                                </>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </>
                        ) : (
                            <NoDataItem
                                fetchRecords={fetchRecords}
                                title={title_item}
                                subtitle={subtitle_empty}
                                item={img_empty}
                                showBtn={false}
                                dbType={"sql"}
                            />

                        )}
                    </div>
                ) : (
                    <NoDataItem
                        fetchRecords={fetchRecords}
                        title={title_empty}
                        subtitle={subtitle_empty}
                        item={img_empty}
                        showBtn={true}
                        dbType={"sql"}
                    />
                )}


            </div>
            <NewTableModal
                show={openModal}
                handleClose={() => setOpenModal(false)}
                fetchRecords={fetchRecords}
                schema={schema}
                schemas={schemas}
                setSchema={setSchema}
                instanceData={instanceData}
            />
            <APIConnectorModal
                show={showAPIConn}
                handleClose={() => setShowApiConn(false)}
                tableDetails={tableDetails}
                db_id={db_id}
                region={region}
            />

            <DeleteRecordModal
                show={showDeleteModal}
                handleClose={handleClose}
                recordObject={recordObject}
                fetchRecords={RefreshTable}
                endpoint={"delete_specific_table"}
                record_type={"Delete"}
                message="This action CANNOT be undone. It will permanently delete the resource and all associated data."
            />
        </div>

    )
}

export default MainSqlData